import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractEntityService } from '@app/shared/abstract/abstract-entity.service';
import { EventProductItemModel } from '@app/events/shared/event-product-item.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EventProductItemService extends AbstractEntityService<EventProductItemModel> {
  constructor(http: HttpClient) {
    super('/api/event-product-items', http);
  }

  /**
   * Calculate price for product item without saving (preview endpoint)
   * Single source of truth: uses backend API for all price calculations
   */
  calculatePrice(payload: {
    product_id: number;
    event_id: number;
    quantity: number;
    amount?: number | null;
    variant_selections?: Array<{
      variant_id: number;
      variant_option_id: number | null;
      quantity: number;
    }>;
  }): Observable<{ calculated_price: number }> {
    return this.http.post<{ calculated_price: number }>(
      `${this.apiUrl}${this.basePath}/calculate-price`,
      payload
    );
  }

  updateTimelineLink(eventProductItemId: number, eventTimelineItemId: number | null) {
    return this.http.patch<{ data: EventProductItemModel }>(
      `${this.apiUrl}${this.basePath}/${eventProductItemId}/timeline-link`,
      { event_timeline_item_id: eventTimelineItemId }
    );
  }

  /**
   * TVG-81: persist the staff drag-and-drop product order for an event. The
   * ordered ids become the single source of truth applied across the customer
   * portal, admin event view, admin PDF, finance page and overall event PDF.
   */
  reorder(eventId: number, orderedIds: number[]): Observable<{ message: string }> {
    return this.http.patch<{ message: string }>(
      `${this.apiUrl}/api/events/${eventId}/product-items/reorder`,
      { ordered_ids: orderedIds }
    );
  }
}
